import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AppbarComponent } from './appbar/appbar.component';
import { NewStoreComponent } from './new-store/new-store.component';
import { HomeComponent } from './home/home.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'ng2-tooltip-directive';
import { OrderComponent } from './order/order.component';
import { MenuComponent } from './menu/menu.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { StoreComponent } from './store/store.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { HelpComponent } from './help/help.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ContactComponent } from './contact/contact.component';
import { ReportComponent } from './report/report.component';
import { ChartsModule } from 'ng2-charts';
import { StarsComponent } from './stars/stars.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'new', component: NewStoreComponent },
  { path: 'home', component: HomeComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'contact', component: ContactComponent },
  { path: '',   redirectTo: '/login', pathMatch: 'full' },
  { path: '**',   redirectTo: '/login', pathMatch: 'full' },
]

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AppbarComponent,
    NewStoreComponent,
    HomeComponent,
    SidebarComponent,
    OrderComponent,
    MenuComponent,
    StoreComponent,
    SafeUrlPipe,
    HelpComponent,
    PrivacyComponent,
    ContactComponent,
    ReportComponent,
    StarsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    RouterModule.forRoot(routes),
    FontAwesomeModule,
    TooltipModule,
    ModalModule.forRoot(),
    ChartsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
